export enum CustomerApiTags {
  customer = "Customer",
  customersList = "CustomersList",
}
